import React from "react";
import {getAllMatchups, advanceContestantToNextRound} from "../../utilities/js/bracket/BracketCreationHelper";
import BracketDisplay from "../../components/bracket/BracketDisplay";
import { 
    getDoubleElimMatchups, 
    advanceDoubleElimContestantToNextRound, 
    moveLoserToDoubleElimBracket, 
    updateFinalRoundOfMainBracket,
    advanceLoserForFinalMatch,
    clearFinalMatch,
    addDoubleRoundsToMainBracket
} from "../../utilities/js/bracket/DoubleElimBracketHelper";
import BracksetFooter from "components/reusable/BracksetFooter";
import BracksetHeader from "components/reusable/BracksetHeader";


class BracketContainer extends React.Component {
    
    constructor(props){
        super(props);
        
        let bracket = null;
        let doubleElimBracket = null;
        
        if(this.props.defaultBracket){
            bracket = this.props.defaultBracket;
            doubleElimBracket = this.props.defaultDoubleElimBracket;
        }else{
            if(Object.keys(this.props.settings.contestantMap).length > 1){
                bracket = getAllMatchups('single', 2, this.props.settings.contestantMap);
                
                if(Object.keys(this.props.settings.contestantMap).length > 3){
                    let doubleElimSetup = getDoubleElimMatchups(bracket);
                    bracket = doubleElimSetup.bracket;
                    doubleElimBracket = doubleElimSetup.losersBracket;
                    if(this.props.settings.isDoubleElim){
                        bracket = addDoubleRoundsToMainBracket(bracket, doubleElimBracket);
                    }
                }
            }
        }
        
        this.state = {
            bracket: bracket,
            competitorsPerMatchup: 2,
            doubleElimBracket: doubleElimBracket,
            contestantMap: this.props.settings.contestantMap,
            tourneyName: this.props.settings.tourneyName

        };
        
        
        if(this.props.storeBrackets){
            this.props.storeBrackets({bracket: bracket, doubleElimBracket: doubleElimBracket});
        }
        
        this.advanceContestant = this.advanceContestant.bind(this);
        this.advanceDoubleElimContestant = this.advanceDoubleElimContestant.bind(this);
        this.recreateBracket = this.recreateBracket.bind(this);
        this.resetBracket = this.resetBracket.bind(this);
    }

    //Maybe find a better way to do this?
    //Currently, we change props, run render, then call componentDidUpdate, then render again
    //Would be nice: Change props, componentDidUpdate, render
    componentDidUpdate(prevProps, prevState) {
        if(prevProps.settings.contestantMap !== this.props.settings.contestantMap && Object.keys(this.props.settings.contestantMap).length > 1){
            this.recreateBracket(this.props.settings.contestantMap);
        }
        if (prevProps.settings.isDoubleElim !== this.props.settings.isDoubleElim) {
            //TODO: Consider propogating the placements within the double elim tournament instead of resetting the whole bracket
            this.recreateBracket(this.props.settings.contestantMap);
        }
        
        if(this.props.storeBrackets){
            if(prevState.bracket !== this.state.bracket || prevState.doubleElimBracket !== this.state.doubleElimBracket){
                this.props.storeBrackets({bracket: this.state.bracket, doubleElimBracket: this.state.doubleElimBracket});
            }
        }
    }
    
    resetBracket(){
        this.recreateBracket(this.props.settings.contestantMap);
    } 
    
    advanceContestant(winner, loser, matchup){
        let bracket = this.state.bracket;
        let doubleElimBracket = this.state.doubleElimBracket;
        
        if(matchup.isDoubleElimPossibleFinal){
            if(matchup.players[1].id === winner.id){
                bracket = advanceContestantToNextRound(this.state.bracket, this.state.competitorsPerMatchup, winner, matchup, true);
                bracket = advanceLoserForFinalMatch(bracket, loser);
            }else{
                bracket = clearFinalMatch(bracket, matchup, winner);
            }
            
        }else{
            bracket = advanceContestantToNextRound(bracket, this.state.competitorsPerMatchup, winner, matchup, true);
            if(this.props.settings.isDoubleElim && matchup.nextOnLoss){
                doubleElimBracket = moveLoserToDoubleElimBracket(bracket, this.state.doubleElimBracket, this.state.competitorsPerMatchup, loser, matchup);
                this.setState({doubleElimBracket: doubleElimBracket});
            }
        }
        
        this.setState({bracket: bracket});
        this.props.storeBrackets({bracket: bracket, doubleElimBracket: doubleElimBracket});
    }
    
    advanceDoubleElimContestant(winner, loser, matchup){
        let bracket = this.state.bracket;
        let doubleElimBracket = advanceDoubleElimContestantToNextRound(this.state.bracket, this.state.doubleElimBracket, this.state.competitorsPerMatchup, winner, matchup, true);
        if(doubleElimBracket.length === matchup.round + 1){
            bracket = updateFinalRoundOfMainBracket(this.state.bracket, winner);
            this.setState({bracket: bracket});
        }
        this.setState({doubleElimBracket: doubleElimBracket});
        this.props.storeBrackets({bracket: bracket, doubleElimBracket: doubleElimBracket});
    }
    
    recreateBracket(contestantMap){
        
        if(Object.keys(contestantMap).length > 1){
            let bracket = getAllMatchups('single', 2, contestantMap);
            let doubleElimBracket = null;
            
            if(Object.keys(contestantMap).length > 3){
                
                let doubleElimSetup = getDoubleElimMatchups(bracket);
                bracket = doubleElimSetup.bracket;
                doubleElimBracket = doubleElimSetup.losersBracket;
                if(this.props.settings.isDoubleElim){
                    bracket = addDoubleRoundsToMainBracket(bracket, doubleElimBracket);
                }
            }
            
            this.setState({
                bracket: bracket,
                competitorsPerMatchup: 2,
                doubleElimBracket: doubleElimBracket,
                contestantMap: contestantMap,
                isDoubleElim: this.props.settings.isDoubleElim
            });
        }
    }
    
    get doubleElimDisplay(){
        
        let hideByes = this.props.settings.hideByes !== undefined ? this.props.settings.hideByes : false;
        let isDoubleElim = this.props.settings.isDoubleElim !== undefined ? this.props.settings.isDoubleElim : false;
        
        let doubleElimDisplay = (<div></div>);
        if(isDoubleElim && this.state.doubleElimBracket){
            doubleElimDisplay = <BracketDisplay 
                settings={this.props.settings}
                header="Double Elimination Bracket" 
                bracket={this.state.doubleElimBracket} 
                contestantMap={this.state.contestantMap} 
                advanceContestant={this.advanceDoubleElimContestant} 
                bracketRecord={this.props.bracketRecord} 
                isLocked={this.props.isLocked}>
            </BracketDisplay>
        }
        
        return doubleElimDisplay;
    }
    
    get bracketDisplay(){
        
        // let hideByes = this.props.hideByes !== undefined ? this.props.hideByes : false;
        
        let bracketDisplay = (<div></div>);
        if(this.state.bracket){
            bracketDisplay = (<div className="main-bracket">
            <BracketDisplay 
                settings={this.props.settings}
                header={this.props.settings.tourneyName} 
                bracket={this.state.bracket} 
                contestantMap={this.state.contestantMap} 
                advanceContestant={this.advanceContestant} 
                format="tournament" 
                // hideByes={hideByes} 
                bracketRecord={this.props.bracketRecord} 
                onReset={this.resetBracket} 
                onPublishClick={this.props.onPublishClick} 
                onSettingsClick={this.props.onSettingsClick} 
                isLocked={this.props.isLocked}>
            </BracketDisplay>
            </div>);
        }
        return bracketDisplay;
    }
    
    render(){    
        
        return (
            <div className="brackset-container">
                <div className="hide-desktop">
                    <BracksetHeader hideSearch="true"></BracksetHeader>
                </div>
                <div className="brackets-display">
                    {this.bracketDisplay}
                    {this.doubleElimDisplay}
                </div>
                {/* <BracksetFooter></BracksetFooter> */}
            </div>
        )
    }
}
    
export default BracketContainer;
    